<template>
    <button
        data-cy="quick-access-nav-item"
        class="nav-option"
        :class="{ 'is-open': isOpen, expanded }"
        :aria-label="label"
        :aria-expanded="isOpen.toString()">
        <div class="nav-icon">
            <svg
                class="filled-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="var(--icon-stroke-base)"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2,12a10,10 0 1,0 20,0a10,10 0 1,0 -20,0"
                    stroke="var(--icon-stroke-base)" />
                <path
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 6 12 12 16 14"
                    stroke="var(--icon-stroke-inverse)" />
            </svg>
            <svg
                class="empty-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2,12a10,10 0 1,0 20,0a10,10 0 1,0 -20,0"
                    stroke="var(--icon-stroke-base)" />
                <path
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 6 12 12 16 14"
                    stroke="var(--icon-stroke-base)" />
            </svg>
            <div
                v-show="expanded"
                class="label-text">
                {{ label }}
            </div>
        </div>
    </button>
</template>

<script>
export default {
    name: 'QuickAccess',
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        label () {
            return this.$t('sideNav.Quick access');
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';
</style>
